<app-ts1-v3-maneuver-breakdown
	[reportSummary]="reportSummary"
	[previewContext]="previewContext"
	[maneuverBreakdownView]="maneuverBreakdownView"
></app-ts1-v3-maneuver-breakdown>
